import { baseApi } from "./baseApi";
import { CompanyResponse } from "../models/api/company/companyResponse";
import { ResponseResult } from "../models/api/responseResult";
import { ErrorResponse } from "../models/api/errorResponse";
import { UserCompanyData } from "../models/api/auth/signUpRequest";
import { UpdateCompanyRequest } from "../models/api/company/updateCompanyRequest";

export const companyApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        companiesByUserId: builder.query<[CompanyResponse], void>({
            query: () => `${import.meta.env.VITE_COMPANIES_CRUD}`,
            providesTags: ["company"],
        }),
        createCompanyByUser: builder.mutation<ResponseResult | ErrorResponse, UserCompanyData>({
            query: (body) => {
                return {
                    url: `${import.meta.env.VITE_COMPANY_CRUD}`,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: ["company"],
        }),
        updateCompanyByUser: builder.mutation<ResponseResult | ErrorResponse, UpdateCompanyRequest>({
            query: (body) => {
                return {
                    url: `${import.meta.env.VITE_COMPANY_CRUD}`,
                    method: "PUT",
                    body,
                };
            },
            invalidatesTags: ["company"],
        }),
        deleteCompany: builder.mutation<ResponseResult | ErrorResponse, number>({
            query: (id) => {
                return {
                    url: `${import.meta.env.VITE_COMPANY_CRUD}/${id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: ["company"],
        }),
    }),
});

export const {
    useCompaniesByUserIdQuery,
    useCreateCompanyByUserMutation,
    useUpdateCompanyByUserMutation,
    useDeleteCompanyMutation,
} = companyApi;
